import { memo } from 'react';
import { Box, Skeleton } from '@bonanza-social/moonlight';
import { BonusInfoSkeletonProps } from './BonusInfoSkeleton.types';

function BonusInfoSkeleton({
  textKey,
  progress,
  imageSize,
  horizontal,
  ...rest
}: BonusInfoSkeletonProps) {
  return (
    <Box
      {...rest}
      flexDirection={horizontal ? 'row' : 'column'}
      gap={horizontal ? 'space-400' : 'space-300'}
    >
      <Skeleton
        alignSelf={horizontal ? undefined : 'center'}
        width={imageSize}
        height={imageSize}
        borderWidth="border-width-050"
        borderColor="borderPrimary"
        borderRadius="radius-200"
      />
      <Box
        flex={horizontal ? 1 : undefined}
        gap="space-100"
        centerContent={!horizontal}
      >
        {textKey && <Skeleton height={19} />}
        <Skeleton height={19} width={horizontal ? undefined : 150} />
        {progress !== undefined ? (
          <Skeleton height={19} marginTop="space-100" />
        ) : null}
      </Box>
    </Box>
  );
}

export default memo(BonusInfoSkeleton);
